import api, { handleAPIErrors } from 'shared/api'

const FETCH_REQUEST = 'directors/FETCH_REQUEST'
const FETCH_SUCCESS = 'directors/FETCH_SUCCESS'
const FETCH_FAILURE = 'directors/FETCH_FAILURE'
const FETCH_LIST_REQUEST = 'directors/FETCH_LIST_REQUEST'
const FETCH_LIST_SUCCESS = 'directors/FETCH_LIST_SUCCESS'
const FETCH_LIST_FAILURE = 'directors/FETCH_LIST_FAILURE'

const initialState = {
  directors: [{
    id: 0,
    avatar_url: '',
    affiliate_name: '',
    name: '',
    company_board_members: [{
      end_date: '',
      start_date: ''
    }],
    company_remunerations: [],
    director_shares: [{
      company_board_member_id: ''
    }],
    private_company_board_members: [{
      end_date: '',
      start_date: ''
    }],
    private_company_remunerations: [],
    superannuation_board_members: [{
      end_date: '',
      start_date: ''
    }],
    superannuation_remunerations: [],
    company_links: [],
    performance: {
      date: '',
      performance_results: []
    },
    previous_board_performance: [],
    company_csuite_members: [{
      end_date: '',
      start_date: ''
    }],
    csuite_company_remunerations: [],
    csuite_company_shares: [],
    private_company_csuite_members: [{
      end_date: '',
      start_date: ''
    }],
    csuite_private_company_remunerations: [],
    superannuation_csuite_members: [{
      end_date: '',
      start_date: ''
    }],
    csuite_superannuation_remunerations: [],
    csuite_performance: {
      date: '',
      performance_results: []
    },
    remuneration_breakdown: [],
    government_csuite_members: [{
      end_date: '',
      start_date: ''
    }],
    csuite_government_remunerations: [],
    csuite_government_shares: [],
    government_board_members: [{
      end_date: '',
      start_date: ''
    }],
    government_remunerations: [],
    government_shares: [{
      government_board_member_id: ''
    }],
    other_government_csuite_members: [{
      end_date: '',
      start_date: ''
    }],
    other_csuite_government_remunerations: [],
    other_csuite_government_shares: [],
    other_government_board_members: [{
      end_date: '',
      start_date: ''
    }],
    other_government_remunerations: [],
    other_government_shares: [{
      other_government_board_member_id: ''
    }],
    other_organisation_board_members: [{
      end_date: '',
      start_date: ''
    }],
    director_notes: '',
  }],
  directorsList: [],
  loadedIds: [],
  loaded: false,
  loading: false,
  errors: []
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function fetchListSuccess(payload) {
  return {
    type: FETCH_LIST_SUCCESS,
    payload,
  }
}

export function fetchListFailure(errors = []) {
  return {
    type: FETCH_LIST_FAILURE,
    errors,
  }
}

export function loadDirector(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.directors.loadedIds ? state.directors.loadedIds.slice() : []
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchRequest({ loadedIds }))

    return api(`api/v1/directors/${id}`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((json) => {
        dispatch(fetchFailure(json.errors))
      })
  }
}

export function saveDirectorNotes(id, notes, options={}) {
  options['notes'] = notes
  const config = {
    method: 'POST',
    body: JSON.stringify(options)
  }

  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.directors.loadedIds ? state.directors.loadedIds.slice() : []
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchRequest({ loadedIds }))

    return api(`api/v1/directors/${id}/save_notes`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }
        toastr.success('Notes updated successfully.')
        dispatch(fetchSuccess(json))
      })
      .catch((json) => {
        toastr.error(json.errors)
        dispatch(fetchFailure(json.errors))
      })

  }
}

export function loadDirectorsList() {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api('api/v1/directors/directors_board_count', {}, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchListSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchListFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds,
      })
    case FETCH_SUCCESS:
      let createdIndex = state.directors.findIndex(i => i.id == payload.id)
      if (createdIndex < 0) {
        createdIndex = state.directors.length
      }
      return Object.assign({}, state, {
        loading: false,
        errors: [],
        directors: Object.assign([...state.directors], {[createdIndex]: payload}),
      })


      return Object.assign({}, state, {
        loading: false,
        errors: [],
        directors: [
          ...state.directors,
          payload
        ]
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors,
      })
    case FETCH_LIST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        directorsList: payload
      })
    case FETCH_LIST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors,
      })
    default:
      return state
  }
}

